export const REMOVE_QUESTION = "REMOVE_QUESTION"
export const REMOVE_QUESTION_SUCCESS = "REMOVE_QUESTION_SUCCESS"
export const REMOVE_QUESTION_CLEAN = "REMOVE_QUESTION_CLEAN"
export const REMOVE_QUESTION_ERROR = "REMOVE_QUESTION_ERROR"
